import { formatInstantDateToPtBR } from '@/shared/lib';
import type { TrainingMatrixRevisionListItem } from '@/entities/Training';
import { formatRevisionNumber } from './formatRevisionNumber';

export function buildTrainingMatrixRevisionOptionLabel(
  revision: Pick<TrainingMatrixRevisionListItem, 'revision' | 'date'>
): string {
  return `Rev. ${formatRevisionNumber(revision.revision)} - ${formatInstantDateToPtBR(revision.date)}`;
}
